import {createStore} from 'redux';
import reducer from './reducer';

const store = createStore(reducer)

export default store;


// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/store.js